// extracted by mini-css-extract-plugin
export var container = "index-module--container--4Qgpt";
export var email = "index-module--email--dOdEp";
export var hide = "index-module--hide--MVRf+";
export var socialIconsContainer = "index-module--socialIconsContainer--dGwpa";